<template>
  <v-card class="elevation-0">
    <cliente-datos :cliente="cliente"/>
    <cliente-direcciones/>
    <cliente-BI/>
  </v-card>
    <!-- <cliente-fidelizacion/> -->
</template>
<script>
import ClienteDatos from './ClienteDatos'
import ClienteDirecciones from './ClienteDirecciones'
import ClienteBI from './ClienteBI'
import ClienteFidelizacion from './ClienteFidelizacion.vue'
export default {
  components: { ClienteDatos, ClienteDirecciones, ClienteBI, ClienteFidelizacion },
  props: {
    cliente: { type: Object, required: true }
  },
  name: 'clienteSidebar',
  data() {
    return {
      
    }
  },
  created() {
  },
  methods: {
    
  },
}
</script>
